import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Strong_Wind/FeatureServer/1&source=sd)
 *  */
const STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.77,
  colors.amber[300],
  2.1,
  colors.orange[500],
  3.9,
  colors.red[500],
  5.8,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Strong_Wind/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 5.8 – 8", 11],
    ["> 3.9 – 5.8", 9],
    ["> 2.1 – 3.9", 7],
    ["> 0.77 – 2.1", 5],
    ["0 – 0.77", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: STOPS[row[1] as number],
  }));
};

export const strongWinds = {
  stops: STOPS,
  props: getLegendRows(),
};
